import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOskVm } from '../osk-vm.model';

@Injectable({ providedIn: 'root' })
export class OskApprovalService {
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {}

  put(guid: string): Observable<IOskVm> {
    return this.http.put<IOskVm>(`${this.apiUrl}/OskApproval`, { guid });
  }
}
